import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getSavedFiltersPermissions } from '../../../helpers/savedFilters';
import * as IssuesV2Store from '../../../redux/issuesV2';
import type { SavedFiltersPermission } from '../../../helpers/savedFilters';

/**
 * Hook for determining if the user has permission to edit the saved filters,
 * depending on the category. Auto-updates whenever category change.
 */
const useSavedFiltersPermissions = (): SavedFiltersPermission => {
  const category = useSelector(IssuesV2Store.selectors.getIssueCategory);
  return useMemo(() => getSavedFiltersPermissions(category), [category]);
};

export default useSavedFiltersPermissions;
